export const links = {
  support: 'https://kemapp.io/frequently-asked-questions/support',
  universalLinkDomain: 'https://kemapp.io',
  linkToDownloadTheApp: 'https://kemapp.io/download-kem',
  termsAndConditions: 'https://kemapp.io/policies',
  eSignNotice:
    'https://kemapp.io/policies/e-sign-and-electronic-communications-notice',
  privacyPolicy: 'https://kemapp.io/policies/privacy-policy',
  interlaceTerms: 'https://kemapp.io/policies/interlace-spend-card-terms',
}
